import { MainContainer, InputCustom } from "./style";

export default function Input(props) {
  return (
    <MainContainer error={props.error}>
      <InputCustom
        autoFocus
        onChange={(event) =>
          props.onChange && props.onChange(event.target.value)
        }
        {...props}
      />
    </MainContainer>
  );
}
